var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHowToUse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 28,
    viewBox: "0 0 18 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.91 16.6521C17.7114 17.1631 17.2086 17.5008 16.6472 17.5008H8.09437L2.37825 24.0349C2.11719 24.334 1.73869 24.4972 1.35 24.4972C1.19357 24.4972 1.03624 24.4707 0.884194 24.4168C0.353306 24.2318 0 23.7396 0 23.138V3.06333C0 2.54719 0.311119 2.07731 0.79425 1.86513C1.27969 1.65458 1.84669 1.73716 2.24269 2.07731L17.4921 15.2023C17.9663 15.5638 18.0619 16.138 17.91 16.6521Z",
    fill: "#00A524"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.2802 22.6848C13.8142 23.7752 13.3382 25.0806 12.2165 25.6002C11.0943 26.1199 9.75159 25.6568 9.21722 24.566L6.59766 19.2121L8.09391 17.4512H10.7427L13.2802 22.6848Z",
    fill: "#00A524"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowToUse);
export default __webpack_public_path__ + "static/media/how-to-use.9bdfbfe6110117a6d8a0b0d2d3fd516c.svg";
export { ForwardRef as ReactComponent };